/*============================================================================
  YOUTUBE RELATED VIDEOS FIX
============================================================================*/
window.addEventListener('DOMContentLoaded', function() {


    if (window.hideYTActivated) return; 

    setTimeout(function(){
        let onYouTubeIframeAPIReadyCallbacks=[]; 
        let playerWrappers = document.querySelectorAll('li:not(.clone) .hytPlayerWrap');

        if (playerWrappers.length > 0) {
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";

            let firstScriptTag = document.getElementsByTagName('script')[0]; 
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        for (let playerWrap of playerWrappers){

            let playerFrame = playerWrap.querySelector("iframe");

            if(navigator.platform.indexOf("iPhone") != -1 && playerFrame.hasAttribute('data-iphonesrc')) {
                playerFrame.dataset.src = playerFrame.dataset.iphonesrc;
            }

            var PAUSE_EVT_STACK = 0;

            let onPlayerStateChange=function(event){

                if (event.data == YT.PlayerState.PAUSED){
                    PAUSE_EVT_STACK++;
                }
                if (event.data == YT.PlayerState.PLAYING){
                    PAUSE_EVT_STACK = 0;
                }

                if (event.data == YT.PlayerState.ENDED){
                    playerWrap.classList.add("ended");
                }else if (event.data == YT.PlayerState.PAUSED && PAUSE_EVT_STACK <= 1){
                    playerWrap.classList.add("paused");
                }else if (event.data == YT.PlayerState.PLAYING || YT.PlayerState.BUFFERING){
                    playerWrap.classList.remove("ended");
                    playerWrap.classList.remove("paused");
                }
            };

            let player;

            onYouTubeIframeAPIReadyCallbacks.push(function(){
                player = new YT.Player(playerFrame,{
                    events:{
                        'onStateChange': onPlayerStateChange
                    }
                });
            }); 

            playerWrap.addEventListener("click", function(){
                let playerState=player.getPlayerState();

                if (playerState==YT.PlayerState.ENDED){
                    player.seekTo(0);
                }else if (playerState==YT.PlayerState.PAUSED || playerState == YT.PlayerState.CUED){
                    player.playVideo();
                }
            });
        }

        window.onYouTubeIframeAPIReady=function(){
            for (let callback of onYouTubeIframeAPIReadyCallbacks){
                callback();
            }
        }; 

        window.hideYTActivated=true;

    },3000);
});